var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.deductibleTypeOptions,"label":_vm.$t('transportationPermission.deductibleType.label', 'Excess'),"disabled":_vm.disabled,"hint":_vm.hint,"persistent-hint":_vm.persistentHint,"value":_vm.selectedDeductibleType},on:{"input":_vm.selectDeductibleType}})
}
var staticRenderFns = []

export { render, staticRenderFns }